import type { IExpenseResult } from '../../../../models/expense/ExpenseModel';
import styles from '../ExpenseManagement.module.css';

export type ExpenseStatusCellProps = {
  row: IExpenseResult;
};

const getStatusClass = (status: string) => {
  switch (status) {
    case 'Pending':
      return styles.statusPending;
    case 'Approved':
      return styles.statusApproved;
    case 'Rejected':
      return styles.statusRejected;
    default:
      return styles.statusPending;
  }
};

const getStatusText = (status: string) => {
  switch (status) {
    case 'Pending':
      return 'Beklemede';
    case 'Approved':
      return 'Onaylandı';
    case 'Rejected':
      return 'Reddedildi';
    default:
      return 'Beklemede';
  }
};

const ExpenseStatusCell = ({ row }: ExpenseStatusCellProps) => {
  return (
    <span className={`${styles.statusBadge} ${getStatusClass(row.status)}`}>
      {getStatusText(row.status)}
    </span>
  );
};

export default ExpenseStatusCell;
